module.exports = __webpack_public_path__ + "static/media/selectArrowDown.e0cc93cf.svg";